export enum Permissions {
  createNewAccount = 'CreateNewAccount',
  viewAccountContacts = 'ViewAccountContacts',
  createAdminUser = 'CreateAdminUser',
  viewAccounts = 'ViewAccounts',
  saveAccountContact = 'SaveAccountContact',
  viewNonPrimaryContacts = 'ViewNonPrimaryContacts',
  viewOwnersAssociatedAccounts = 'ViewOwnersAssociatedAccounts',
  saveOwnersAssociatedAccounts = 'SaveOwnersAssociatedAccounts',
  viewAccountNameAndAddress = 'ViewAccountNameAndAddress',
  viewClassificationPercentGood = 'ViewClassificationPercentGood',
  viewAccountAssets = 'ViewAccountAssets',
  saveAccountAssets = 'SaveAccountAssets',
  viewAccountLeasedAssets = 'ViewAccountLeasedAssets',
  viewSimilarBusiness = 'ViewSimilarBusiness',
  saveAccountInfo = 'SaveAccountInfo',
  searchAccounts = 'SearchAccounts',
  viewAccountPenalty = 'ViewAccountPenalty',
  reopenSubmittedAccount = 'ReopenSubmittedAccount',
  updateAccountActiveStatus = 'UpdateAccountActiveStatus',
  updateAccountExemptStatus = 'UpdateAccountExemptStatus',
  deleteAccountLink = 'DeleteAccountLink',
  createAccountPin = 'CreateAccountPin',
  viewAccountPin = 'ViewAccountPin',
  sendAccountPinEmail = 'SendAccountPinEmail',
  saveCountySettings = 'SaveCountySettings',
  basicCost = 'BasicCost',
  accountType = 'AccountType',
  countySettings = 'CountySettings',
  propertyClassification = 'PropertyClassification',
  saveAppraisalRegions = 'SaveAppraisalRegions',
  saveParcelUseTypes = 'SaveParcelUseTypes',
  savePaymentTypes = 'SavePaymentTypes',
  savePermitTypes = 'SavePermitTypes',
  saveIndustrialParkTypes = 'SaveIndustrialParkTypes',
  saveSicCodeMasters = 'SaveSicCodeMasters',
  saveSicCodes = 'SaveSicCodes',
  saveSicSiloCodes = 'SaveSicSiloCodes',
  saveSubSiloCodes = 'SaveSubSiloCodes',
  saveTaxRate = 'SaveTaxRate',
  reportAccountValuePriorYearChange = 'ReportAccountValuePriorYearChange',
  reportAccountStatusByAppraisalRegion = 'ReportAccountStatusByAppraisalRegion',
  reportLeaseMasterValueYearToYearChange = 'ReportLeaseMasterValueYearToYearChange',
  reportTaxAreas = 'ReportTaxAreas',
  reportActiveAccounts = 'ReportActiveAccounts',
  reportOverpayment = 'ReportOverpayment',
  reportMissingAppraiserRegion = 'ReportMissingAppraiserRegion',
  reportAccountListForPrinter = 'ReportAccountListForPrinter',
  reportPaymentStatus = 'ReportPaymentStatus',
  reportDepositTotals = 'ReportDepositTotals',
  reportDelinquenctPaymentEntryPrintScreen = 'ReportDelinquenctPaymentEntryPrintScreen',
  reportDelinquentTaxReceipt = 'ReportDelinquentTaxReceipt',
  viewDelinquentPaymentEntry = 'ViewDelinquentPaymentEntry',
  viewDelinquentPaymentHistory = 'ViewDelinquentPaymentHistory',
  recalculateDelinquentPaymentEntry = 'RecalculateDelinquentPaymentEntry',
  createDelinquentPayment = 'CreateDelinquentPayment',
  reportMovePermit = 'ReportMovePermit',
  searchMovePermits = 'SearchMovePermits',
  getMovePermitInitializeCreate = 'GetMovePermitInitializeCreate',
  createMovePermit = 'CreateMovePermit',
  editMovePermit = 'EditMovePermit',
  reportCurrentPaymentSummary = 'ReportCurrentPaymentSummary',
  reportCurrentYearPaymentSummary = 'ReportCurrentYearPaymentSummary',
  reportDailyPaymentTotals = 'ReportDailyPaymentTotals',
  reportFilingStatus = 'ReportFilingStatus',
  reportStatusCsvFile = 'ReportStatusCsvFile',
  reportAccountPaymentContract = 'ReportAccountPaymentContract',
  reportAccountDetail = 'ReportAccountDetail',
  reportAccountSummary = 'ReportAccountSummary',
  reportBalanceDue = 'ReportBalanceDue',
  reportAccountPayment = 'ReportAccountPayment',
  reportAppraisalRegions = 'ReportAppraisalRegions',
  emailSendJurisdictionEarlyFileOnline = 'EmailSendJurisdictionEarlyFileOnline',
  emailSendAccountEarlyFileOnline = 'EmailSendAccountEarlyFileOnline',
  emailSendJurisdictionPin = 'EmailSendJurisdictionPin',
  emailSendAccountPin = 'EmailSendAccountPin',
  emailAccountJurisdictionCount = 'EmailAccountJurisdictionCount',
  impersonate = 'Impersonate',
  fileByPaper = 'FileByPaper',
  searchPayments = 'SearchPayments',
  viewAccountCurrentYearPayment = 'ViewAccountCurrentYearPayment',
  viewCurrentYearSummary = 'ViewCurrentYearSummary',
  viewDelinquentPaymentSummary = 'ViewDelinquentPaymentSummary',
  editDelinquentPayment = 'EditDelinquentPayment',
  savePayment = 'SavePayment',
  createMassPayments = 'CreateMassPayments',
  viewAccountDirectCharge = 'ViewAccountDirectCharge',
  saveDirectCharges = 'SaveDirectCharges',
  editCurrentPayment = 'EditCurrentPayment',
  viewDailyPaymentTotals = 'ViewDailyPaymentTotals',
  viewCurrentYearReturnedCheckInformation = 'ViewCurrentYearReturnedCheckInformation',
  createCurrentYearReturnedCheck = 'CreateCurrentYearReturnedCheck',
  viewAccountPaymentContract = 'ViewAccountPaymentContract',
  viewPaymentPlan = 'ViewAccountPaymentContract',
  savePaymentPlan = 'SavePaymentPlan',
  deletePaymentPlan = 'DeletePaymentPlan',
  getAllPermissions = 'GetAllPermissions',
  createRole = 'CreateRole',
  getAllRoles = 'GetAllRoles',
  getRole = 'GetRole',
  deleteRole = 'DeleteRole',
  editRole = 'EditRole',
  getRolesFromUser = 'GetRolesFromUser',
  addRoleToUser = 'AddRoleToUser',
  removeRoleFromUser = 'RemoveRoleFromUser',
  addPermissionToRole = 'AddPermissionToRole',
  removePermissionFromRole = 'RemovePermissionFromRole',
  getAllAdminUsers = 'GetAllAdminUsers',
  editAdminUser = 'EditAdminUser',
  reportDelinquentPaymentSummary = 'ReportDelinquentPaymentSummary',
  reportPaymentTotalsByPaymentType = 'ReportPaymentTotalsByPaymentType',
  reportPaymentTotalsByAccountType = 'ReportPaymentTotalsByAccountType',
  reportAccountComments = 'ReportAccountComments',
  reportDelinquentAccountList = 'ReportDelinquentAccountList',
  reportEarlyOnlineEmailList = 'ReportEarlyOnlineEmailList',
  reportLeaseMasterAccountDetail = 'ReportLeaseMasterAccountDetail',
  reportCurrentYearPaymentEntryReceipt = 'ReportCurrentYearPaymentEntryReceipt',
  reportLeaseMasterCurrentYearPaymentEntryReceipt = 'ReportLeaseMasterCurrentYearPaymentEntryReceipt',
  reportOneYearExemptEmailList = 'ReportOneYearExemptEmailList',
  reportLeaseMasterSummary = 'ReportLeaseMasterSummary',
  reportAccountSignedStatement = 'ReportAccountSignedStatement',
  reportLeaseMasterSignedStatement = 'ReportLeaseMasterSignedStatement',
  reportDealerInventory = 'ReportDealerInventory',
  reportAccountBalance = 'ReportAccountBalance',
  reportDepositTotalsByTaxArea = 'ReportDepositTotalsByTaxArea',
  reportDelqPaymentSummary = 'ReportDelqPaymentSummary',
  reportAssociatedAccounts = 'ReportAssociatedAccounts',
  reportDelinquentPostcard = 'ReportDelinquentPostcard',
  reportReminderPostcard = 'ReportReminderPostcard',
  reportSubAccountDetail = 'ReportSubAccountDetail',
  reportCoreReconciliation = 'ReportCoreReconciliation',
  eoyCheckListReport = 'EOYCheckListReport',
  reportLeaseMasterIncorrectDistribution = 'ReportLeaseMasterIncorrectDistribution',
  reportReconciliation = 'ReportReconciliation',
  reportBankruptcyAccount = 'ReportBankruptcyAccount',
  reportExemptOrganizationAccount = 'ReportExemptOrganizationAccount',
  reportSuspendedAccounts = 'ReportSuspendedAccounts',
  reportTaxAreaTotalTaxable = 'ReportTaxAreaTotalTaxable',
  noExisted = 'NoExisted',
  getAccountsByAppraiserRegion = 'GetAccountsByAppraiserRegion',
  mergeAppraiserRegion = 'MoveAccountsAppraiserRegion',
  getAccountsByIndustrialPark = 'GetAccountsByIndustrialPark',
  viewDelinquentYearReturnedCheck = 'ViewDelinquentYearReturnedCheck',
  saveDelinquentYearReturnedCheck = 'SaveDelinquentYearReturnedCheck',
  viewDelinquentAdjustment = 'ViewDelinquentAdjustment',
  saveDelinquentAdjustment = 'SaveDelinquentAdjustment',
  reportDelqAdjustmentReceipt = 'ReportDelqAdjustmentReceipt',
  viewDelinquentPaymentsForVoidSearchList = 'ViewDelinquentPaymentsForVoidSearchList',
  viewDelinquentPaymentsForVoid = 'ViewDelinquentPaymentsForVoid',
  viewDelinquentTransactionsForVoid = 'ViewDelinquentTransactionsForVoid',
  postDelinquentTransactionsForVoid = 'PostDelinquentTransactionsForVoid',
  searchRefunds = 'SearchRefunds',
  viewRefundBatch = 'ViewRefundBatch',
}

// The void page is only useful to users who can complete a void, so all of these are required to access it
export const voidDelinquentPaymentPermissions = [
  Permissions.viewDelinquentPaymentsForVoidSearchList,
  Permissions.viewDelinquentPaymentsForVoid,
  Permissions.viewDelinquentTransactionsForVoid,
  Permissions.postDelinquentTransactionsForVoid,
]
